import { isEmpty } from "lodash";
import { MAX_RICH_DESCRIPTION_LENGTH } from "../../../components/shared/RichDescription";

// Synchronous guard against Yup validation race condition: formik.setFieldValue
// + validationSchema run async, so a fast Confirm click right after a long
// paste can fire before formik.errors.richDescription is populated. Checking
// the raw value length here keeps the button disabled immediately.
const isRichDescriptionOverLimit = (formik) => {
  const value = formik?.values?.richDescription;
  return typeof value === "string" && value.length > MAX_RICH_DESCRIPTION_LENGTH;
};

/**
 * Checks if the booking is disabled
 * @param {Object} formik - formik object
 * @param {boolean} isDuplicate - is the booking a duplicate
 * @param {Array} pendingReservations - array of pending reservations
 * @param {boolean} disabledSelection - is the selection disabled
 * @param {boolean} isConflict - is there a conflict with recurring booking
 * @returns {boolean} is the booking disabled
 */
export const isAddBookingDisabled = (formik, isDuplicate, pendingReservations, disabledSelection, isConflict) => {
  const hasErrors = !isEmpty(formik.errors) || isConflict;
  const reservations = isDuplicate
    ? pendingReservations.filter(reservation => !reservation.bookingId)
    : pendingReservations;
  return hasErrors || disabledSelection || reservations.length === 0 || isRichDescriptionOverLimit(formik);
};

/**
 * Checks if saving an edited booking is disabled
 * @param {Object} formik - formik object
 * @param {boolean} disabledSelection - is the selection disabled
 * @param {Array} pendingReservations - array of pending reservations
 * @param {Function} compareValues - function to compare current values with original
 * @returns {boolean} is saving the booking disabled
 */
export const isSaveBookingDisabled = (formik, disabledSelection, pendingReservations, compareValues) => {
  const hasErrors = !isEmpty(formik.errors);
  const hasNoReservations = pendingReservations.length === 0;
  const hasNoChanges = compareValues(formik);
  return hasErrors || disabledSelection || hasNoReservations || hasNoChanges || isRichDescriptionOverLimit(formik);
};
